import { ITabDefinition } from 'aa-ng';

import { ISelectableUnit } from './selectable-unit';

export class SelectableUnitGroup {
  unit: ISelectableUnit;
  tabs: ITabDefinition[];
  _children: ISelectableUnit[];
  children: ISelectableUnit[];
  private _alphabetFilteredUnits: ISelectableUnit[] | null = null;

  constructor(
    unit: ISelectableUnit,
    tabs: ITabDefinition[],
    children: ISelectableUnit[],
  ) {
    this.unit = unit;
    this.tabs = tabs;
    this._children = children;
    this.filterChildren();
  }

  changeView(tab: ITabDefinition): void {
    this.tabs.forEach((x) => (x.isCurrent = x === tab));
    this.filterChildren();
  }

  setAlphabetFilter(filteredUnits: ISelectableUnit[] | null): void {
    this._alphabetFilteredUnits = filteredUnits;
    this.filterChildren();
  }

  filterChildren() {
    let baseChildren = this._children;

    // Apply alphabet filter first if active
    if (this._alphabetFilteredUnits !== null) {
      baseChildren = this._children.filter((child) =>
        this._alphabetFilteredUnits.includes(child),
      );
    }

    // Apply tab filter
    if (this.tabs.length > 1) {
      const tab = this.tabs.find((x) => x.isCurrent);
      if (tab) {
        this.children = baseChildren.filter(tab.data);
      } else {
        this.children = baseChildren;
      }
    } else {
      this.children = baseChildren;
    }
  }
}
